import { BookingReportTypeEnum } from "@lib/enum"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import reportService from "@services/report/reportService"
import { action, makeAutoObservable, observable } from "mobx"

class ReportStore {
  // Booking Report
  @observable dataBookingByDate!: any
  @observable loadingBookingDate!: boolean
  @observable dataBookingByWeek!: any
  @observable loadingBookingWeek!: boolean
  @observable dataBookingByMonth!: any
  @observable loadingBookingMonth!: boolean
  @observable dataDailyCollection!: PagedResultDto<any>
  @observable loadingDailyCollection!: boolean
  @observable dataDueDate!: PagedResultDto<any>
  @observable loadingDueDate!: boolean
  @observable dataSaleStatus!: PagedResultDto<any>
  @observable loadingSaleStatus!: boolean
  @observable dataQuickCollection!: PagedResultDto<any>
  @observable loadingQuickCollection!: boolean
  @observable dataRevenueStatement!: PagedResultDto<any>
  @observable loadingRevenueStatement!: boolean
  @observable dataDebitNote!: PagedResultDto<any>
  @observable loadingDebitNote!: boolean
  @observable dataArAging!: PagedResultDto<any>
  @observable loadingArAging!: boolean
  @observable dataAgingSum!: PagedResultDto<any>
  @observable loadingAgingSum!: boolean
  @observable dataAgingGroup!: PagedResultDto<any>
  @observable loadingAgingGroup!: boolean

  @observable dataDashboard!: any
  @observable loadingDashboard!: boolean
  constructor() {
    makeAutoObservable(this)
    this.dataBookingByDate = { allAgencyMasters: [], dat: [] }
    this.dataBookingByWeek = { allAgencyMasters: [], data: [] }
    this.dataBookingByMonth = { allAgencyMasters: [], data: [] }
    this.dataDailyCollection = { items: [], totalCount: 0 }
    this.dataDueDate = { items: [], totalCount: 0 }
    this.dataSaleStatus = { items: [], totalCount: 0 }
    this.dataQuickCollection = { items: [], totalCount: 0 }
    this.dataRevenueStatement = { items: [], totalCount: 0 }
    this.dataDebitNote = { items: [], totalCount: 0 }
    this.dataArAging = { items: [], totalCount: 0 }
    this.dataAgingSum = { items: [], totalCount: 0 }
    this.dataAgingGroup = { items: [], totalCount: 0 }
    this.loadingBookingDate = false
    this.loadingBookingWeek = false
    this.loadingBookingMonth = false
    this.loadingAgingGroup = false
    this.loadingAgingSum = false
    this.loadingArAging = false
    this.loadingDebitNote = false
    this.loadingDueDate = false
    this.loadingQuickCollection = false
    this.loadingRevenueStatement = false
    this.loadingSaleStatus = false
    
  }
  @action
  getReportByDate = async (params) => {
    this.loadingBookingDate = true
    this.dataBookingByDate = await reportService
      .getReport({
        ...params,
        type: BookingReportTypeEnum.Day,
      })
      .finally(() => (this.loadingBookingDate = false))
  }
  @action
  getReportByWeek = async (params) => {
    this.loadingBookingWeek = true
    this.dataBookingByWeek = await reportService
      .getReport({ ...params, type: BookingReportTypeEnum.Week })
      .finally(() => (this.loadingBookingWeek = false))
  }
  @action
  getReportByMonth = async (params) => {
    this.loadingBookingMonth = true
    this.dataBookingByMonth = await reportService
      .getReport({ ...params, type: BookingReportTypeEnum.Month })
      .finally(() => (this.loadingBookingMonth = false))
  }

  @action
  getDailyCollection = async (params) => {
    this.loadingDailyCollection = true
    this.dataDailyCollection = await reportService
      .getDailyCollection(params)
      .finally(() => (this.loadingDailyCollection = false))
    return this.dataDailyCollection
  }

  @action
  exportDailyCollection = async (params) => {
    this.loadingDailyCollection = true
    await reportService.exportDailyCollection(params)
    .finally(() => (this.loadingDailyCollection = false))
  }

  @action
  getDueDate = async (params) => {
    this.loadingDueDate = true
    this.dataDueDate = await reportService
      .getDueDate(params)
      .finally(() => (this.loadingDueDate = false))
    return this.dataDueDate
  }

  @action
  exportDueDate = async (params) => {
    this.loadingDueDate = true
    await reportService.exportDueDate(params)
    .finally(() => (this.loadingDueDate = false))
  }

  @action
  getQuickCollection = async (params) => {
    this.loadingQuickCollection = true
    this.dataQuickCollection = await reportService.getQuickCollection(params)
    .finally(() => (this.loadingQuickCollection = false))
    return this.dataQuickCollection
  }

  @action
  exportQuickCollection = async (params) => {
    this.loadingQuickCollection = true
    await reportService.exportQuickCollection(params)
    .finally(() => (this.loadingQuickCollection = false))
  }

  @action
  getRevenueStatement = async (params) => {
    this.loadingRevenueStatement = true
    this.dataRevenueStatement = await reportService.getRevenueStatement(params)
    .finally(() => (this.loadingRevenueStatement = false))
    return this.dataRevenueStatement
  }

  /**
   * Export Core: PHẢI return kết quả — `null` = đã tải tệp, object = job nền đã vào hàng đợi.
   * Bỏ kết quả thì scene không biết đã bị queue và người dùng tưởng export thất bại.
   */
  @action
  exportRevenueStatement = async (params) => {
    this.loadingRevenueStatement = true
    return await reportService.exportRevenueStatement(params)
    .finally(() => (this.loadingRevenueStatement = false))
  }

  @action
  getDebitNote = async (params) => {
    this.loadingDebitNote = true
    this.dataDebitNote = await reportService.GetReportDebitNote(params)
    .finally(() => (this.loadingDebitNote = false))
    return this.dataDebitNote
  }

  /** Xem `exportRevenueStatement` — return kết quả để scene rẽ nhánh queued. */
  @action
  exportDebitNote = async (params) => {
    this.loadingDebitNote = true
    return await reportService.exportDebitNote(params)
    .finally(() => (this.loadingDebitNote = false))
  }

  @action
  getArAging = async (params) => {
    this.loadingArAging = true
    this.dataArAging = await reportService.GetReportArAging(params)
    .finally(() => (this.loadingArAging = false))
    return this.dataArAging
  }

  @action
  exportArAging = async (params) => {
    this.loadingArAging = true
    await reportService.exportArAging(params)
    .finally(() => (this.loadingArAging = false))
  }

  @action
  getAgingSum = async (params) => {
    this.loadingAgingSum = true
    this.dataAgingSum = await reportService.GetReportAgingSum(params)
    .finally(() => (this.loadingAgingSum = false))
    return this.dataAgingSum
  }

  @action
  exportAgingSum = async (params) => {
    this.loadingAgingSum = true
    await reportService.exportAgingSum(params)
    .finally(() => (this.loadingAgingSum = false))
  }

  @action
  getAgingGroup = async (params) => {
    this.loadingAgingGroup = true
    this.dataAgingGroup = await reportService.GetReportAgingGroup(params)
    .finally(() => (this.loadingAgingGroup = false))
    return this.dataAgingGroup
  }

  @action
  exportAgingGroup = async (params) => {
    this.loadingAgingGroup = true
    await reportService.exportAgingGroup(params)
    .finally(() => (this.loadingAgingGroup = false))
  }

  @action
  getSalesStatus = async (params) => {
    this.loadingSaleStatus = true
    this.dataSaleStatus = await reportService.GetReportSaleStatus(params)
    .finally(() => (this.loadingSaleStatus = false))
    return this.dataSaleStatus
  }

  @action
  exportSalesStatus = async (params) => {
    this.loadingSaleStatus = true
    await reportService.exportSaleStatus(params)
    .finally(() => (this.loadingSaleStatus = false))
  }
  

}

export default ReportStore
